var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.696,
    height: 28,
    viewBox: "0 0 26.696 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cogwheel_3524577",
    d: "M26.7,17.122s0,0,0,0L24.9,15.469a11.75,11.75,0,0,0,0-2.938l1.8-1.653a1.772,1.772,0,0,0,.327-2.164l-1.98-3.423A1.757,1.757,0,0,0,23,4.5l-2.329.735a10.671,10.671,0,0,0-2.538-1.474l-.538-2.39A1.756,1.756,0,0,0,15.89,0H11.923a1.756,1.756,0,0,0-1.7,1.365L9.685,3.757A10.671,10.671,0,0,0,7.147,5.23L4.816,4.5a1.754,1.754,0,0,0-2.042.789L.786,8.721a1.77,1.77,0,0,0,.336,2.162l1.794,1.648A11.925,11.925,0,0,0,2.823,14a12.154,12.154,0,0,0,.092,1.469l-1.8,1.653A1.77,1.77,0,0,0,.79,19.285l1.98,3.423a1.757,1.757,0,0,0,2.049.8l2.329-.735a10.671,10.671,0,0,0,2.538,1.474l.538,2.389A1.755,1.755,0,0,0,11.923,28H15.89a1.756,1.756,0,0,0,1.7-1.365l.538-2.392a10.631,10.631,0,0,0,2.537-1.474L23,23.5a1.752,1.752,0,0,0,2.043-.79l1.988-3.437a1.769,1.769,0,0,0-.331-2.156Zm-12.79,2.711A5.833,5.833,0,1,1,19.74,14a5.84,5.84,0,0,1-5.833,5.833Z",
    transform: "translate(-0.559 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting_icon.3d72d1b3626dc40f6b3a4a8e19b37c01.svg";
export { ForwardRef as ReactComponent };